module.exports = __webpack_public_path__ + "static/media/tran_failed.7f95d79c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tran_failed.svg
// module id = 805
// module chunks = 0